import { useParams } from 'react-router';

import { useGetReuseById } from 'src/api/reuse';

export function useReuseName() {
  const { reuse_id } = useParams();
  const { reuse } = useGetReuseById(reuse_id);

  return reuse?.name;
}
